import React from 'react';
export const FocusContainmentContext = /*#__PURE__*/ React.createContext({
    contain: true,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setContain: ()=>{}
});
export const FocusContainmentProvider = ({ children })=>{
    const [contain, setContain] = React.useState(true);
    return /*#__PURE__*/ React.createElement(FocusContainmentContext.Provider, {
        value: {
            contain,
            setContain
        }
    }, children);
};
export const useFocusContainment = ()=>{
    const { contain, setContain } = React.useContext(FocusContainmentContext);
    return {
        contain,
        setContain
    };
};

//# sourceMappingURL=FocusContainmentProvider.js.map